import { AnyAction } from 'redux'
import { StringDictionary } from 'shared/types/util'
import type { State } from 'shared/types/gallery/state'

const initialState: State.QvFilterNameByTaxonomyIdState = {}

export function reducer(state: State.QvFilterNameByTaxonomyIdState = initialState, action: AnyAction): StringDictionary<string> {
  switch (action.type) {
    default:
      return state
  }
}

export const qvFilterNameByTaxonomyIdSelector = (state: State.GlobalState): StringDictionary<string> => state.qvFilterNameByTaxonomyId
